import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Releases from './Releases'
import Files from './Files'
import Documents from './Documents'
import WrappedTabs from '../../common/WrappedTabs'
import { loadFirmwarePrefixes, loadFirmwareTypes } from '../../../actions/firmware'
import { loadLanguages, loadModels } from '../../../actions/shared'

const firmwarePages = [
  {
    key: 0,
    title: 'releases',
    content: <Releases />,
  },
  {
    key: 1,
    title: 'software_files',
    content: <Files />,
  },
  {
    key: 2,
    title: 'instruction_files',
    content: <Documents />,
  },
]

const Firmware = (props) => {
  const { t } = useTranslation()
  const [selectedPage, setSelectedPage] = useState(firmwarePages[0])

  useEffect(() => {
    if (props.prefixes.length === 0) {
      props.actions.loadFirmwarePrefixes()
    }

    if (props.types.length === 0) {
      props.actions.loadFirmwareTypes()
    }

    if (props.languages.length === 0) {
      props.actions.loadLanguages()
    }

    if (props.models.length === 0) {
      props.actions.loadModels()
    }
  }, [props.actions])

  const handleTabClick = (index) => {
    const page = firmwarePages.find(({ key }) => key === index)
    setSelectedPage(page)
  }

  return (
    <>
      <WrappedTabs
        containerId="firmware-tabs"
        className="main-page-tabs-wrapper internal-tabs"
        tabs={firmwarePages.map((page) => ({ id: page.key, name: page.title }))}
        activeTab={selectedPage?.key}
        changeTab={handleTabClick}
      />
      {selectedPage?.content && selectedPage.content}
    </>
  )
}

function stateToProps({ firmware, shared }) {
  return {
    prefixes: firmware?.prefixes || [],
    types: firmware?.types || [],
    languages: shared?.languages?.map((l) => l.languageCode) || [],
    models: shared?.models || [],
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadFirmwareTypes,
        loadFirmwarePrefixes,
        loadLanguages,
        loadModels,
      },
      dispatch,
    ),
  }
}

export default connect(stateToProps, dispatchToProps)(Firmware)
